import { RequestKind, boolean } from '@sb/library/base';
import { BatchBillingProfileUpdateItems, BillingProfileDisplayItem, BillingProfileInputItem, BillingProfileSearchOptions, BillingProfileUpdateItem, DisplayItemCollection, IDResultItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace BillingProfilesRoutes {
    export const Get = ApiRoute.Define({
        URL: (studentID: string, teacherID: string) => `/students/${studentID}/teachers/${teacherID}/billingprofiles`,
        Kind: RequestKind.Get,
        ResultType: BillingProfileDisplayItem
    });

    export const Search = ApiRoute.Define({
        URL: '/search/billingprofiles',
        Kind: RequestKind.Post,
        BodyType: BillingProfileSearchOptions,
        ResultType: DisplayItemCollection<BillingProfileDisplayItem>,
        PagingAllowed: true
    });

    export const Update = ApiRoute.Define({
        URL: (studentID: string, teacherID: string) => `/students/${studentID}/teachers/${teacherID}/billingprofiles`,
        Kind: RequestKind.Put,
        BodyType: BillingProfileUpdateItem,
        ResultType: boolean
    });

    export const Batch = ApiRoute.Define({
        URL: 'billingprofiles',
        Kind: RequestKind.Patch,
        BodyType: BatchBillingProfileUpdateItems,
        ResultType: Array<Array<IDResultItem>>
    });

    export const Add = ApiRoute.Define({
        URL: 'billingprofiles',
        Kind: RequestKind.Post,
        BodyType: BillingProfileInputItem,
        ResultType: Array<IDResultItem>
    });

    export const Delete = ApiRoute.Define({
        URL: (studentID: string, teacherID: string) => `/students/${studentID}/teachers/${teacherID}/billingprofiles`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });
}
